"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Typography = _interopRequireDefault(require("../../atoms/Typography"));
var _Image = _interopRequireDefault(require("../../atoms/Image"));
var _Icon = _interopRequireDefault(require("../../atoms/Icon"));
var _Column = _interopRequireDefault(require("../../layout/Column"));
var _Row = _interopRequireDefault(require("../../layout/Row"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  name: '',
  description: '',
  role: '',
  image: '',
  defaultIcon: 'account_circle',
  className: '',
  onClick() {}
};
function UserCard(props) {
  const {
    name,
    image,
    description,
    role,
    className,
    onClick
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  return /*#__PURE__*/_react.default.createElement(Container, {
    gap: 5,
    onClick: onClick,
    className: className
  }, /*#__PURE__*/_react.default.createElement(StyledRoleLabel, {
    type: "helper",
    children: role,
    size: 12,
    weight: 700,
    show: (role === null || role === void 0 ? void 0 : role.length) > 0
  }), /*#__PURE__*/_react.default.createElement(StyledRow, {
    gap: 10
  }, image ? /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: image,
    alt: "".concat(name, "'s profile"),
    width: 50,
    height: 50,
    rounded: 50
  }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "account_circle",
    size: 50
  }), /*#__PURE__*/_react.default.createElement(_Column.default, {
    gap: 0,
    align: "top"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: "default",
    size: 16,
    weight: 700,
    children: name
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: "description",
    size: 14,
    children: description
  }))));
}
const Container = (0, _styled.default)(_Column.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  img,\n  .material-icons {\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n  }\n"])));
const StyledRoleLabel = (0, _styled.default)(_Typography.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  opacity: ", ";\n"])), _ref => {
  let {
    show
  } = _ref;
  return show ? 1 : 0;
});
const StyledRow = (0, _styled.default)(_Row.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  @media screen and (min-width: 768px) {\n    .material-icons {\n      font-size: 60px;\n    }\n\n    [type='default'] {\n      font-size: 22px;\n      line-height: normal;\n    }\n\n    [type='description'] {\n      font-size: 16px;\n      line-height: normal;\n    }\n  }\n"])));
var _default = exports.default = UserCard;